<template>
  <div class="flex padding">
    <form
        v-if="!success"
        @submit.prevent="submitForm"
        enctype="multipart/form-data"
    >
        <div class="form-fields-stack">
            <div class="form-field col col-6">
                <input type="text" placeholder="First Name" v-model="payload.first_name" name="first_name" required>
                <span class="validate" v-if="errors.first_name">{{ errors.first_name }}</span>
            </div>
            <div class="form-field col col-6">
                <input type="text" placeholder="Last Name" name="last_name" v-model="payload.last_name"  required>
                <span class="validate" v-if="errors.last_name">{{ errors.last_name }}</span>
            </div>
        </div>

        <div class="form-fields-stack">
            <div class="form-field col col-6">
                <input type="text" placeholder="Email Address" v-model="payload.email"  name="email" required>
                <span class="validate" v-if="errors.email">{{ errors.email }}</span>
            </div>

            <div class="form-field col col-6">
                <input type="text" placeholder="Phone Number" v-model="payload.phone"  name="phone" required>
                <span class="validate" v-if="errors.phone">{{ errors.phone }}</span>
            </div>
        </div>

        <div class="form-field col col-6 reason">
          <p @click="toggleReasonDropdown" :class="{ placeholder: selectedReason == 'Reason for Contact' }">{{ selectedReason }} </p><img src="/images/icons/arrow-down.png" alt="">
          <ul v-show="showingReasonDropdown">
              <li v-for="rfc in reasonsForContact" :key="rfc" :class="{ active: rfc == selectedReason }" @click="selectReason(rfc)">{{ rfc }}</li>
          </ul>
        </div>

        <div v-if="selectedReason == 'Job application'" class="form-field col col-12">
            <input type="text" placeholder="Job Title" v-model="payload.job_title"  name="job-title" class="job-title" required>
        </div>

        <div class="form-field col col-12 message">
            <textarea type="text" placeholder="Your Message" name="message" required v-model="payload.message"></textarea>
            <span class="validate" v-if="errors.message">{{ errors.message }}</span>
        </div>

        <slot></slot>

        <!-- <div v-show="selectedReason == 'Job application'" class="job-application">
        <h6>Upload your CV and Cover Letter</h6>
        <p>(max file size 2mb)</p>
        </div> -->

        <div v-if="selectedReason == 'Job application'" class="job-application">
            <h6>Upload your CV and Cover Letter</h6>
            <p>(max file size 2mb)</p>
            <app-file-input v-on:files="uploadedFile"></app-file-input>
        </div>


    		<span class="form-required">All fields are required</span>

        <label class="custom-checkbox">
          Sign up to email newsletter
          <input type="checkbox" checked="checked">
          <span class="checkmark"></span>
        </label>

        <div class="form-field col col-12">
            <button class="button" type="submit">Send</button>
        </div>

    </form>

    <div class="wrap success" v-else>
      <h3>Thank you!</h3>
      <p>Contact form has been sent.</p>
    </div>
</div>
</template>
<script>
export default {
  props: [
    'module_type'
  ],
  data () {
    return {
      success: false,
      message: '',
      showingReasonDropdown: false,
      selectedReason: 'Reason for Contact',
      reasonsForContact: [
        "Job application",
        "I'm a landlord",
        "I'm a developer",
        "I want to volunteer",
        "Housing Enquiry",
        "Other",
      ],
      payload: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        message: null,
        job_title: null,
        files: [],
      },
      errors: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        message: null,
      },
    }
  },

  mounted ()
  {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    console.log('params', params.get("title"));
    if (params.get("title")) {
        this.payload.message = 'I am enquiring about ' + params.get("title")
    }

    if (params.get("reason") && this.reasonsForContact.includes(params.get("reason"))) {
        this.selectedReason = params.get("reason")
    }
    else {
        this.selectedReason = 'Reason for Contact'

    }
  },

  methods: {
    toggleReasonDropdown () {
      this.showingReasonDropdown = ! this.showingReasonDropdown
    },

    selectReason (reason) {
      this.selectedReason = reason
      this.showingReasonDropdown = false
    },

    uploadedFile (file) {
      console.log('file', file)
      this.payload.files = file
    },

    submitForm () {
      this.$parent.isLoaded = false

      let headerPayload = { headers: { 'Content-Type': 'multipart/form-data' } }
      let formData = new FormData()

      formData.append('first_name', this.payload.first_name)
      formData.append('last_name', this.payload.last_name)
      formData.append('email', this.payload.email)
      formData.append('data[reason_for_contact]', this.selectedReason)
      if(this.payload.job_title){
        formData.append('data[job_title]', this.payload.job_title)
      }
      formData.append('message', this.payload.message)

    //   formData.append('data[reason]', this.payload.reason)

      if (this.payload.files[0]) {
        formData.append('files', this.payload.files[0])
      }

      axios.post('/form-submission/' + this.module_type, formData, headerPayload)
        .then((res) => {
            this.$parent.isLoaded = true

            if (res.data.success) {
            this.success = true
            }
        })
        .catch((error) => {
            this.$parent.isLoaded = true
            this.success = false

            if (error.response.status == 422) {
                this.$parent.isLoaded = true
                this.success = false

                this.errors = error.response.data.errors
                console.log(error.response.status)
                console.log(error.response.data.errors)
                console.log(this.errors)
            }
        })
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Contact.vue